import { CORE_ACTION } from "../types/CoreAction";

const removeDownloadSnack = (snackBarId: string) => {
  return {
    type: CORE_ACTION.REMOVE_DOWNLOAD_SNACK,
    payload: snackBarId,
  };
};

export default removeDownloadSnack;
